import React from 'react';
import { i18n } from '@lt/localization';
import CustomBooleanFilterGroup from '../components/CustomBooleanFilterGroup';

import type { IFilter } from '../types';

const FILTER_NAMES = {
  pool: i18n.t('filters.spa.pool'),
  heated_pool: i18n.t('filters.spa.heated_pool'),
  aquapark: i18n.t('filters.spa.aquapark'),
  thermal_fun: i18n.t('filters.spa.thermal_fun'),
};

const FilterSpa = ({
  className = '',
  isMobile = false,
  ...props
}: IFilter): JSX.Element => (
  <CustomBooleanFilterGroup
    className={className}
    isMobile={isMobile}
    {...props}
    Filter={{
      filterLabel: i18n.t('filters.spa.title'),
      FILTER_NAMES,
      customFilters: Object.keys(FILTER_NAMES),
    }}
  />
);

export default Object.assign(FilterSpa, {
  filterName: 'spa',
  filterLabel: i18n.t('filters.spa.title'),
  FILTER_NAMES,
  customFilters: Object.keys(FILTER_NAMES),
});
